import { ChevronLeftIcon, ChevronRightIcon, PlusIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useOffersStore } from "../../stores/offersStore";
import { useStepsStore } from "./EditOffer/state";
import { ActionButton } from "../../components/wrappers/WithActionBar";
import { useDisable } from "./state";

export const OfferActionBar = ({ disableDrafting }: { disableDrafting?: boolean }) => {
  const steps = useStepsStore();
  const { offerYachts } = useOffersStore();
  const disabled = useDisable();
  return (
    <div className="flex justify-between items-center">
      <Button onClick={steps.previousStep} disabled={steps.isFirstStep} variant="outline">
        <ChevronLeftIcon size={16} />
        Back
      </Button>
      <div className="flex items-center gap-4">
        {steps.step === "Yachts" && (
          <ActionButton disabled={!offerYachts?.length} variant="outline" eventKey="offer:openYachtsModal">
            Added to the offer ({offerYachts?.length})
          </ActionButton>
        )}
        {!disableDrafting && (
          <ActionButton variant="outline" eventKey="offer:draft">
            Draft
          </ActionButton>
        )}
        {steps.isLastStep && <ActionButton eventKey="offer:save">Save</ActionButton>}
        {!steps.isLastStep && (
          <Button disabled={disabled} onClick={steps.nextStep}>
            Next <ChevronRightIcon size={16} />
          </Button>
        )}
      </div>
    </div>
  );
};
